module.exports = __webpack_public_path__ + "img/illusCorona2.fc7f1287.jpg";